export default __webpack_public_path__ + "static/media/academiccounseling.5075a36a.svg";